export default "__VITE_ASSET__lKk8r3F0__"